import { Injectable } from '@angular/core';
import { StorageEnums } from 'src/shared/models/enums';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  constructor() {}

  public async clearOnLogout(): Promise<void> {
		await this.removeItem(StorageEnums.AUTH_TOKEN);
		await this.removeItem(StorageEnums.REFRESH_TOKEN);
		await this.removeItem(StorageEnums.USER_FIELDS_VERIFIED);
		await this.removeItem(StorageEnums.USER_LOGGED_IN);
		await this.removeItem(StorageEnums.WISH_TOWER_INFORMATION);
		await this.removeItem(StorageEnums.USER_ID);
		await this.removeItem(StorageEnums.USER_LOCATION);
	}

  	public async setItem<T = any>(key: StorageEnums, data: T): Promise<T> {
		const value = this.compress<T>(data);
		sessionStorage.setItem(key, value);
		return data;
	}

  	public async getItem<T = any>(key: StorageEnums): Promise<T | null> {
		try {
			const value = sessionStorage.getItem(key);
			return this.parse<T>(value) ?? null;
		} catch (error) {
			return null;
		}
	}

	public async removeItem(key: StorageEnums): Promise<void> {
		sessionStorage.removeItem(key);
	}

	private parse<T = any>(value: string | null): T | undefined {
		if (!value) {
			return undefined;
		}
		try {
			return JSON.parse(value) as T;
		} catch (error) {
			return undefined;
		}
	}

	private compress<T = any>(value: T): string {
		return JSON.stringify(value);
	}
}